import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { Card, Typography } from '@otp/ui';
import { Link } from 'src/components/common/link';
import styles from '../index.module.css';
import Grid from '@mui/material/Grid';
import { Routes } from 'src/components/common/router/constants';
import { useNavigate } from 'react-router-dom';
import { Actions, AppArea, Subjects } from 'src/graphql/generated/graphql';
import { useCan } from 'src/utils/can';

export const AdditionalResources = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { can } = useCan();

  const canReadQuickLinks = can({
    action: Actions.Read,
    appArea: AppArea.Common,
    subject: Subjects.Lms,
  });

  const canReadAdditionalResources = can({
    action: Actions.Read,
    appArea: AppArea.Common,
    subject: Subjects.Common,
  });

  const quickLinks = [
    {
      title: t('my-organisation.additional-resources.card.community-app'),
      route: 'https://app.joinblink.com/#/home',
    },
    {
      title: t('my-organisation.additional-resources.card.otp-training-path'),
      route: Routes.lmsCurriculums.path,
    },
    {
      title: t('my-organisation.additional-resources.card.learning-path'),
      route:
        'https://truegroup-my.sharepoint.com/:b:/g/personal/evan_blust_truegroup_net/EV3DNuKPcyxPr82xm1Re3r0BsdXee36pS1ycJVHpP5KG6w?e=fSA5xp',
    },
  ];

  const additionalResources = [
    {
      title: 'my-organisation.additional-resources.card.technology-site',
      route:
        'https://www.atmcd.com/sites/us/technology/SitePage/2460001/us-tech-landing-page',
    },
    {
      title: 'my-organisation.additional-resources.card.sherlock',
      route: 'https://sherlock.mcd.com/',
    },
    {
      title:
        'my-organisation.additional-resources.card.dt-technology-health-walk-thru',
      route:
        'https://otp.mcd.com/documents/51b2f028-ca16-436a-943b-1fac2eec29a9/download',
    },
    {
      title: 'my-organisation.additional-resources.card.mc-d-connect',
      route: 'https://app.joinblink.com/#/login',
    },
    {
      title:
        'my-organisation.additional-resources.card.vhq-verifone-headquarters',
      route: 'https://vhqmcdgui.verifone.com/Home/Logout',
    },
    {
      title:
        'my-organisation.additional-resources.card.rrm-remote-restaurant-manager',
      route:
        'https://us-east-2.protection.sophos.com/?d=atmcd.com&u=aHR0cHM6Ly93d3cuYXRtY2QuY29tL3NpdGVzL3VzL3VzLXRlY2hub2xvZ3kvU2l0ZVBhZ2VNb2Rlcm4vMjY5MTY4MS91LXMtcmVzdGF1cmFudC1wbGF0Zm9ybS1mb3VuZGF0aW9u&i=NWRmYjg1ZDQ5MmM3OWUwZGNjZjdkNDk4&t=bkhNSHdTMVM4MmV1aW05czh4VU5OT2ZrWUk0eGdJNE4zb1AxazVKYWhJWT0=&h=0b3520f12ab64029b5871aceae6f8c28&s=AVNPUEhUT0NFTkNSWVBUSVYUAH4j22sK6hgq4DrSWEnhc31KT1fjrb4F81-V79ZFRQ',
    },
    {
      title: 'my-organisation.additional-resources.card.myqsrsoft',
      route: 'https://home.myqsrsoft.com/login',
    },
    {
      title: 'my-organisation.additional-resources.card.qsrsoft-cash-inventory',
      route: 'https://prod.ebos.qsrsoft.com/',
    },
    {
      title: 'my-organisation.additional-resources.card.cost-analyzer',
      route: 'https://otp.mcd.com/costanalyzer/',
    },
    {
      title: 'my-organisation.additional-resources.card.service-now',
      route:
        'https://atostransform.service-now.com/login_with_sso.do?glide_sso_id=47f5172d9850a100ec68bb4ceca90fb6',
    },
  ];

  const allResources = [
    ...(canReadQuickLinks ? quickLinks : []),
    ...(canReadAdditionalResources ? additionalResources : []),
  ];

  return (
    <Grid container spacing={2}>
      {allResources.map((resource) => (
        <Grid item xs={12} sm={6} md={3} key={resource.title}>
          <Link to={resource.route} className="w-full">
            <Card
              padding={2}
              isLink
              className="bg-[#F8F9FD] border-none flex group hover:bg-[#F8B92A] hover:border-none transition-colors rounded-lg items-center w-full h-full"
              linkIconClassName={clsx(
                styles.linkIconCustom,
                'absolute top-1/2 right-2 transform -translate-y-1/2 transition-colors',
              )}
            >
              <Typography
                variant="subtitle1"
                fontWeight="medium"
                fontFamily="Inter"
                fontSize={14}
              >
                {t(resource.title)}
              </Typography>
            </Card>
          </Link>
        </Grid>
      ))}
    </Grid>
  );
};
